/**
 * Framework tags (ADR-0012): the built-in list as toggle chips, plus any tag an
 * author types. Labels, not control mapping (that stays Phase 3).
 */
import { useState } from "react";
import { FRAMEWORKS, MAX_FRAMEWORK_TAGS, normalizeFramework } from "../lib/brand";

export function FrameworkPicker({ value, onChange, disabled }: { value: string[]; onChange: (v: string[]) => void; disabled?: boolean }) {
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const has = (f: string) => value.some((v) => v.toLowerCase() === f.toLowerCase());
  const toggle = (f: string) => onChange(has(f) ? value.filter((v) => v.toLowerCase() !== f.toLowerCase()) : [...value, f].slice(0, MAX_FRAMEWORK_TAGS));
  const custom = value.filter((v) => !(FRAMEWORKS as readonly string[]).includes(v));
  const add = () => {
    const n = normalizeFramework(text);
    if (!n) { setErr(text.trim() ? "Use letters, numbers, spaces and . & / + - (30 characters max)." : ""); return; }
    if (value.length >= MAX_FRAMEWORK_TAGS) { setErr(`Up to ${MAX_FRAMEWORK_TAGS} tags.`); return; }
    if (!has(n)) onChange([...value, n]);
    setText(""); setErr("");
  };
  return (
    <div className="fw-picker">
      <div className="chips">
        {FRAMEWORKS.map((f) => (
          <button type="button" key={f} className={`chip fw ${has(f) ? "on" : ""}`} aria-pressed={has(f)} disabled={disabled} onClick={() => toggle(f)}>
            {has(f) ? "✓ " : ""}{f}
          </button>
        ))}
        {custom.map((f) => (
          <button type="button" key={f} className="chip fw on" disabled={disabled} onClick={() => toggle(f)} title="Remove this tag">✓ {f} ×</button>
        ))}
      </div>
      <div className="fw-add">
        <input className="inp" value={text} placeholder="Another framework or contract, e.g. CJIS" maxLength={30} disabled={disabled}
          onChange={(e) => { setText(e.target.value); setErr(""); }}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} aria-label="Add a framework tag" />
        <button type="button" className="btn btn-ghost btn-sm" onClick={add} disabled={disabled || !text.trim()}>Add</button>
      </div>
      {err && <div className="help" style={{ color: "var(--bad)", margin: "4px 0 0" }}>{err}</div>}
    </div>
  );
}

/** Small read-only tag chips (library rows, details panel). */
export function FrameworkTags({ tags, max }: { tags: string[]; max?: number }) {
  if (!tags?.length) return null;
  const shown = max ? tags.slice(0, max) : tags;
  return (
    <span className="fw-tags">
      {shown.map((t) => <span key={t} className="fw-tag">{t}</span>)}
      {max && tags.length > max ? <span className="fw-tag more">+{tags.length - max}</span> : null}
    </span>
  );
}
